const processEnv: any = {
  ...process.env,
  ...((window as any).AppSettings || {}),
};

export const AppSettings = {
  APP_API_URL: processEnv.REACT_APP_API_URL,
  APP_PUBLIC_API_BASE_PATH: processEnv.REACT_PUBLIC_API_BASE_PATH,
  APP_AZURE_CLIENT_ID: processEnv.REACT_APP_AZURE_CLIENT_ID,
  APP_AZURE_AUTHORITY: processEnv.REACT_APP_AZURE_AUTHORITY,
  APP_AZURE_REDIRECT_URI: processEnv.REACT_APP_AZURE_REDIRECT_URI,
  APP_BASE_APP_URL:processEnv.REACT_APP_BASE_APP_URL,
  APP_APP_NAME: processEnv.REACT_APP_APP_NAME,
  APP_AUTH_TYPE: processEnv.REACT_AUTH_TYPE
};
